import { Form, DatePicker as AntDDatePicker } from 'antd'
import { useField } from 'formik'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import { useCallback } from 'react'

const { Item } = Form

export default function DatePicker({
  containerClassName = undefined,
  label = '',
  defaultPickerValue = undefined,
  maxDate = dayjs(),
  layout = undefined,
  ...rest
}) {
  const [field, { error, touched }, { setTouched, setValue }] = useField(rest)
  const handleBlur = useCallback(() => setTouched(true), [setTouched])
  const hasError = Boolean(touched && error)

  // Ensure the value is compatible with Ant Design v5's DatePicker (uses dayjs)
  if (typeof field.value === 'string') field.value = dayjs(field.value)

  return (
    <Item
      className={containerClassName}
      label={label}
      hasFeedback={false}
      validateStatus={hasError ? 'error' : ''}
      help={hasError && error}
      layout={layout}
    >
      <AntDDatePicker
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...field}
        value={
          typeof field.value === 'string' ? dayjs(field.value) : field.value
        } // Use dayjs-compatible value
        onChange={setValue}
        onBlur={handleBlur}
        format="MM/DD/YYYY"
        maxDate={maxDate}
        defaultPickerValue={!field.value ? defaultPickerValue : undefined}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      />
    </Item>
  )
}

DatePicker.propTypes = {
  containerClassName: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
  defaultPickerValue: PropTypes.shape(),
  defaultValue: PropTypes.shape(),
  maxDate: PropTypes.shape(),
  layout: PropTypes.string,
}
